import React from 'react';
import ProductsService from '../services/ourProducts.services';
import OurService from '../services/services.service';

class OurServicesController extends React.Component {
  constructor(props) {
    super(props);
  }

  async servicesListing() {
    let response = await OurService.productsListing();
    if (response && response.status) {
      return response;
    } else {
      // new Toaster().error(response.error);
      return null;
    }
  }

  async servicesDetails(id) {
    let response = await OurService.productsDetails(id);
    if (response && response.status) {
      return response;
    } else {
      //new Toaster().error(response.error);
      return null;
    }
  }

  async servicesCategories() {
    let response = await OurService.servicesCategories();
    if (response && response.status) {
      return response;
    } else {
      // new Toaster().error(response.error);
      return null;
    }
  }

}

export default OurServicesController;
